import { render, staticRenderFns } from "./WsExamLogsList.vue?vue&type=template&id=150dc669"
import script from "./WsExamLogsList.vue?vue&type=script&lang=js"
export * from "./WsExamLogsList.vue?vue&type=script&lang=js"
import style0 from "./WsExamLogsList.vue?vue&type=style&index=0&id=150dc669&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports